import {
    IMovimentacaoBulkActionOption,
    IMovimentacaoOrderingOption,
    IMovimentacaoUiStatusOption,
    TMovimentacaoUiStatusKey
} from '../models/movimentacoes.index.model';
import { IMovimentacaoDisplayModeOption } from '../components/listagem/movimentacoes-listagem.model';

export {
    MOVIMENTACAO_UNIDADE_DIAS,
    MOVIMENTACAO_UNIDADE_MONETARIA,
    MOVIMENTACAO_UNIDADES_HORAS
} from '../../constants/movimentacoes-unidades.constants';

export const MOVIMENTACAO_ORDERING_OPTIONS: IMovimentacaoOrderingOption[] = [
    {
        value: 'ordem',
        label: 'Data de lançamento',
        order: { ordem: 'DESC' }
    },
    {
        value: 'trabalhador',
        label: 'Colaborador',
        order: { 'trabalhador.nome': 'ASC', ordem: 'DESC' }
    },
    {
        value: 'evento',
        label: 'Rubrica',
        order: { 'evento.nome': 'ASC', ordem: 'DESC' }
    },
    {
        value: 'lotacao',
        label: 'Lotação',
        order: { 'lotacao.nome': 'ASC', ordem: 'DESC' }
    }
];

export const MOVIMENTACAO_DISPLAY_MODE_OPTIONS: IMovimentacaoDisplayModeOption[] = [
    {
        value: 'flat',
        label: 'Lista'
    },
    {
        value: 'group_by_trabalhador',
        label: 'Colaborador'
    },
    {
        value: 'group_by_evento',
        label: 'Rubrica'
    }
];

export const MOVIMENTACAO_STATUS_OPTIONS: IMovimentacaoUiStatusOption[] = [
    {
        value: 'rascunho',
        label: 'Rascunho',
        situacao: 0,
        total: null,
        counterTone: 'gray',
        filter: [{ condition: 'eq', value: 0 }]
    },
    {
        value: 'enviado',
        label: 'Enviado',
        situacao: 1,
        wkfEstado: [{ condition: 'neq', value: 'AGUARDANDO_ESTORNO' }],
        total: null,
        counterTone: 'blue',
        filter: [{ condition: 'eq', value: 1 }]
    },
    {
        value: 'a_validar',
        label: 'A validar',
        situacao: 1,
        fase: 1,
        total: null,
        counterTone: 'blue',
        filter: [{ condition: 'eq', value: 1 }]
    },
    {
        value: 'efetuado',
        label: 'Efetuado',
        situacao: 2,
        total: null,
        counterTone: 'green',
        filter: [{ condition: 'eq', value: 2 }]
    },
    {
        value: 'aguardando_estorno',
        label: 'Aguardando estorno',
        situacao: 1,
        wkfEstado: [{ condition: 'eq', value: 'AGUARDANDO_ESTORNO' }],
        total: null,
        counterTone: 'yellow',
        filter: [{ condition: 'eq', value: 1 }]
    },
    {
        value: 'recusado',
        label: 'Recusado',
        situacao: 5,
        total: null,
        counterTone: 'red',
        filter: [{ condition: 'eq', value: 5 }]
    },
    {
        value: 'cancelado',
        label: 'Cancelado',
        situacao: 4,
        total: null,
        counterTone: 'red',
        filter: [{ condition: 'eq', value: 4 }]
    },
    {
        value: 'estornado',
        label: 'Estornado',
        situacao: 6,
        total: null,
        counterTone: 'gray',
        filter: [{ condition: 'eq', value: 6 }]
    },
    {
        value: 'todos',
        label: 'Todos',
        total: null,
        counterTone: 'blue',
        filter: [{ condition: 'neq', value: 3 }]
    }
];

export const MOVIMENTACAO_BULK_ACTIONS_BY_STATUS: Partial<Record<TMovimentacaoUiStatusKey, IMovimentacaoBulkActionOption[]>> = {
    rascunho: [
        {
            value: 'send',
            label: 'Enviar em lote',
            icon: 'fa fa-paper-plane',
            selectionLabel: 'Enviar',
            selectionTone: 'primary'
        },
        {
            value: 'delete',
            label: 'Excluir em lote',
            icon: 'fa fa-trash',
            selectionLabel: 'Excluir',
            selectionTone: 'danger'
        }
    ],
    enviado: [
        {
            value: 'cancel',
            label: 'Cancelar envio em lote',
            icon: 'fa fa-ban',
            selectionLabel: 'Cancelar envio',
            selectionTone: 'primary'
        }
    ],
    a_validar: [
        {
            value: 'approve',
            label: 'Aprovar em lote',
            icon: 'fa fa-check',
            selectionLabel: 'Aprovar',
            selectionTone: 'primary'
        }
    ]
};

export const MOVIMENTACAO_UI_STATUS_LABELS: Record<number, string> = {
    0: 'Rascunho',
    1: 'Enviado',
    2: 'Efetuado',
    3: 'Excluído',
    4: 'Cancelado',
    5: 'Recusado',
    6: 'Estornado'
};

export const MOVIMENTACAO_UI_STATUS_CLASSNAMES: Record<number, string> = {
    0: 'label-default',
    1: 'label-primary',
    2: 'label-success',
    3: 'label-default',
    4: 'label-danger',
    5: 'label-danger',
    6: 'label-default'
};
